/*
 * cities — the world's ~10,000 largest cities (English/Latin names + population),
 * sorted by population descending. Drives the world map's ONE-LANGUAGE city-label
 * layer: place names for orientation WITHOUT the multi-script clutter of a raster
 * basemap's baked labels (which is why the basemap is `nolabels`).
 */
import { CITIES_RAW } from './cities-data';
export const CITIES = CITIES_RAW.map(([name, cc, lat, lng, pop]) => ({ name, cc, lat, lng, pop }));
//# sourceMappingURL=cities.js.map